import { useAnalytics } from '../useAnalytics.js';
import { useMockPreview } from '../useMockPreview.js';
import { type ResourceNode, type UseResourceNodeReturn } from './types.js';
import { getDisabledAnchorProps } from './util.js';
import { type ServiceNode } from '@/types/services.js';
import { useMemo } from 'react';

export const useServiceNode = ({
  index,
  node,
}: ResourceNode<ServiceNode>): ServiceNode & UseResourceNodeReturn => {
  const { analyticsId, slug } = node;
  const { track } = useAnalytics();
  const { isMockNode } = useMockPreview();
  const isMock = isMockNode(node);

  const anchorProps = useMemo(() => {
    const clickCallback = () => {
      track('link', {
        action: 'tapped',
        link_name: 'ip_view_service',
        position_index: index,
        service_id: analyticsId,
      });
    };

    return isMock
      ? getDisabledAnchorProps()
      : {
          onClick: clickCallback,
          onKeyDown: clickCallback,
          role: 'button',
          tabIndex: 0,
        };
  }, [analyticsId, index, isMock, track]);

  const href = useMemo(() => {
    return !slug || isMock ? '' : `/s/${slug}`;
  }, [isMock, slug]);

  return useMemo(
    () => ({
      ...node,
      anchorProps,
      href,
      isMock,
    }),
    [anchorProps, href, isMock, node],
  );
};
